/* eslint-disable */
const formatPrice = (price, className) => {
    return price.replace(/^(.?)(.*)(.|,)(\d{2})(.?)$/i, function(str, symb1, p1, p2, p3, symb2, i, s){
        let symb1Val = symb1 ? symb1 : '';
        let p1Val = p1 ? p1 : '';
        let p2Val = p2 ? p2 : '';
        let p3Val = p3 ? p3 : '';
        let symb2Val = symb2 ? `&nbsp;${symb2}` : '';

        return `${symb1Val}${p1Val}${p2Val}<span class=${className}>${p3Val}</span>${symb2Val}`;
    });
};

export default formatPrice;
